import { render, staticRenderFns } from "./QuestionTree.vue?vue&type=template&id=5b6b0845&lang=pug&"
import script from "./QuestionTree.vue?vue&type=script&lang=js&"
export * from "./QuestionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports